<h2 mat-dialog-title>{{ 'AUDIT.ANNOTATE.TITLE' | translate }}</h2>

<mat-dialog-content class="photo-annotate">
  <p class="photo-annotate__hint">
    {{ 'AUDIT.ANNOTATE.HINT' | translate }}
    @if (data.replacesCopy) {
      {{ 'AUDIT.ANNOTATE.REPLACES_COPY' | translate }}
    }
  </p>

  <div class="photo-annotate__toolbar">
    <mat-button-toggle-group [value]="tool" (change)="setTool($event.value)" hideSingleSelectionIndicator>
      <mat-button-toggle value="select" [matTooltip]="'AUDIT.ANNOTATE.TOOL_SELECT' | translate">
        <mat-icon>pan_tool_alt</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="arrow" [matTooltip]="'AUDIT.ANNOTATE.TOOL_ARROW' | translate">
        <mat-icon>arrow_outward</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="ellipse" [matTooltip]="'AUDIT.ANNOTATE.TOOL_ELLIPSE' | translate">
        <mat-icon>circle</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="text" [matTooltip]="'AUDIT.ANNOTATE.TOOL_TEXT' | translate">
        <mat-icon>title</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <div class="photo-annotate__colors">
      @for (c of colors; track c) {
        <button type="button" class="photo-annotate__color" [class.is-active]="c === color"
                [style.background]="c" [attr.aria-label]="c" (click)="setColor(c)"></button>
      }
    </div>

    <!-- Always laid out, only hidden: showing it must not change the toolbar's height (the photo
         below would jump). -->
    <mat-form-field appearance="outline" color="accent" class="photo-annotate__text" subscriptSizing="dynamic"
                    [class.is-hidden]="!showsTextField" [attr.aria-hidden]="!showsTextField">
      <mat-label>{{ 'AUDIT.ANNOTATE.TEXT' | translate }}</mat-label>
      <input matInput maxlength="200" [ngModel]="text" (ngModelChange)="onTextChange($event)"
             [tabindex]="showsTextField ? 0 : -1" />
    </mat-form-field>

    <span class="flex-1"></span>

    <button mat-icon-button type="button" [disabled]="shapes.length === 0"
            [matTooltip]="'AUDIT.ANNOTATE.UNDO' | translate" (click)="undo()">
      <mat-icon>undo</mat-icon>
    </button>
    <button mat-icon-button type="button" [disabled]="!selected"
            [matTooltip]="'AUDIT.ANNOTATE.DELETE' | translate" (click)="deleteSelected()">
      <mat-icon>delete_outline</mat-icon>
    </button>
  </div>

  <div class="photo-annotate__stage" [class.is-drawing]="tool !== 'select'">
    @if (loading) {
      <div class="photo-annotate__placeholder"><mat-spinner diameter="40"></mat-spinner></div>
    }
    @if (loadFailed) {
      <div class="photo-annotate__placeholder">{{ 'AUDIT.ANNOTATE.LOAD_ERROR' | translate }}</div>
    }
    <div #stageHost class="photo-annotate__host"></div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="dialogRef.close(false)">{{ 'ACTION.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" type="button"
          [disabled]="saving || loading || shapes.length === 0" (click)="save()">
    {{ 'AUDIT.ANNOTATE.SAVE' | translate }}
  </button>
</mat-dialog-actions>
